module.exports = __webpack_public_path__ + "static/img/bg7.649fa49e.png";